import API_CONFIG from "./api_config";

/**
 * Sends an email via an asynchronous POST request.
 *
 * @param {Object} data - The email payload in JSON format.
 * @returns {Promise<Response>} A promise resolving to the server's response.
 * @throws {Error} If the network request encounters an error.
 */
const sendEmail = async (data) => {
  const url = `${API_CONFIG.BACKEND_URL}/send-email`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export default sendEmail;
